import React from "react";
import { motion } from "framer-motion";
import { Users, Eye, TrendingUp, Instagram } from "lucide-react";
import { fadeUp, viewportOnce } from "../../lib/ui";

const STATS = [
  { icon: Users, value: "598", label: "Instagram Followers", bg: "bg-white" },
  { icon: Eye, value: "5–10K", label: "Avg. Reel Views", bg: "bg-clay-lime" },
  { icon: TrendingUp, value: "94.3K", label: "Views · Last 30 Days", bg: "bg-clay-pink text-white" },
  { icon: Instagram, value: "@hi._.manganese", label: "Say hi on Instagram", bg: "bg-clay-surface", small: true },
];

export const Metrics = () => {
  return (
    <section id="metrics" data-testid="metrics-section" className="px-4 py-20 sm:px-6 sm:py-28">
      <div className="mx-auto max-w-6xl">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="mb-12 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end"
        >
          <div>
            <span className="font-body text-sm font-bold uppercase tracking-widest text-clay-violet">
              By the numbers
            </span>
            <h2 className="mt-3 font-display text-4xl font-black tracking-tighter text-clay-ink sm:text-6xl">
              The proof, in pixels.
            </h2>
          </div>
          <p className="max-w-xs font-body text-sm font-medium text-clay-ink/70">
            Pulled straight from the Instagram Professional Dashboard.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              custom={i}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={viewportOnce}
              className={`flex flex-col justify-between rounded-[2rem] border-[3px] border-clay-ink ${s.bg} p-6 shadow-clay`}
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl border-[3px] border-clay-ink bg-white/90 shadow-brutal-sm">
                <s.icon className="h-5 w-5 text-clay-violetdeep" strokeWidth={2.25} />
              </span>
              <div className="mt-8">
                <p className={`font-display font-black leading-none tracking-tighter ${s.small ? "text-2xl break-words" : "text-5xl"}`}>
                  {s.value}
                </p>
                <p className="mt-2 font-body text-sm font-bold uppercase tracking-wide opacity-80">
                  {s.label}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
